/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import Content from "../../../Components/Dashboard/Content/Content";
import { GET_COMPANY_INFOS } from "../../../ReduxStore/Slice/Admin/AdminSlice";
import { DisclaimerMessage } from "../../../ReduxStore/Slice/Admin/SystemSlice";
import {
  Pencil,
  Building2,
  Mail,
  Image,
  FileText,
  Upload,
  Server,
  Globe,
  Shield,
  Camera,
  Send,
} from "lucide-react";
import ToastButton from "../../../Components/ExtraComponents/Alert_Toast";
import toast from "react-hot-toast";
import $ from "jquery";
import UpdateCompanyInfo from "./UpdateCompanyInfo";
import UpdateImages from "./UpdateImages";
import UpdateSmptDetails from "./UpdateSmptDetails";
import { useDispatch } from "react-redux";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import axios from "axios";
import * as Config from "../../../Utils/Config";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { RemoveImagebycompany } from "../../../ReduxStore/Slice/Admin/SystemSlice";
import Swal from "sweetalert2";

const System = () => {

  
  const dispatch = useDispatch();
  const [diss, setDiss] = useState("");
  const [inputs, setInputs] = useState([]);
  const [getDissStatus, setDissStatus] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [showImgModal, setshowImgModal] = useState(false);
  const [ShowEmailModal, setShowEmailModal] = useState(false);
  const [PanelDetailsModal, setPanelDetailsModal] = useState(false);
  const [emailLogoImg, setEmailLogoImg] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [getCompanyName, setCompanyName] = useState({
    loading: true,
    data: [],
  });
  const [pdfFileExist, setpdfFileExist] = useState({ live: false, data: "" });
  const [pdfFile, setPdfFile] = useState(null);

  const PageStatus = localStorage.getItem("pageStatus") || 1;
  const setPageStatus = (k) => localStorage.setItem("pageStatus", k);

  useEffect(() => {
    CompanyName();
  }, []);

  const CompanyName = async () => {
    const response = await dispatch(GET_COMPANY_INFOS()).unwrap();
    if (response.status) {
      const [companyInfo] = response.data;
      setPreviewUrl(companyInfo.Emaillogo);
      setDiss(companyInfo.disclaimer);
      setDissStatus(companyInfo.disclaimer_status);
      setInputs(companyInfo.dissArr);
      setCompanyName({ loading: false, data: response.data });
      setpdfFileExist({
        live: true,
        data:
          "https://" +
          response.data[0]?.domain_url +
          "/pdfs/" +
          response.data[0]?.welcome_message_pdf,
      });

      let favicon = $("link[rel='icon']").length
        ? $("link[rel='icon']")
        : $("<link rel='icon' type='image/x-icon' />");
      favicon.attr("href", companyInfo.favicon);
      $("head").append(favicon);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEmailLogoImg(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const Removeimages = async (type) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to remove this image?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, remove it!",
        cancelButtonText: "No, cancel",
      });

      if (result.isConfirmed) {
        const data = { type };
        const response = await dispatch(
          RemoveImagebycompany({ req: data })
        ).unwrap();

        if (response.status) {
          Swal.fire("Deleted!", "Image removed successfully.", "success");
          CompanyName();
        } else {
          Swal.fire(
            "Failed!",
            response.msg || "Failed to remove image",
            "error"
          );
          CompanyName();
        }
      } else {
        Swal.fire("alert", "Image removal cancelled");
        CompanyName();
      }
    } catch (error) {
      Swal.fire("Error!", "Something went wrong while removing image", "error");
      console.error("Removeimages error:", error);
    }
  };

  const UpdateEmailLogo = async () => {
    if (!emailLogoImg) return alert("Please select an image first!");
    const formData = new FormData();
    formData.append("image", emailLogoImg);

    try {
      const res = await axios.post(
        Config.base_url + "update/email/logo",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      res.status
        ? toast.success("Email Logo updated successfully!")
        : toast.error("Error updating Email Logo!");
    } catch (error) {
      toast.error("Image upload failed");
    }
  };

  const handleSubmit = async () => {
    const data1 = inputs.map((input, index) => ({
      id: index + 1,
      value: input.value,
    }));
    const payload = {
      id: "6501756b2a8e6d952493b7f4",
      disclaimer: diss,
      dataArr: data1,
    };

    const response = await dispatch(DisclaimerMessage(payload)).unwrap();
    response.status
      ? toast.success("Disclaimer added successfully...")
      : toast.error("Disclaimer add error");
    setRefresh(!refresh);
  };

  const updateDiscStatus = async (e) => {
    const payload = {
      id: "6501756b2a8e6d952493b7f4",
      disclaimer_status: e.target.checked ? "1" : "0",
    };
    const response = await dispatch(DisclaimerMessage(payload)).unwrap();
    response.status
      ? window.location.reload()
      : toast.error("Disclaimer status update error");
  };

  const handlePdfUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setPdfFile(file);
      const fileURL = URL.createObjectURL(file);
      setpdfFileExist({ live: false, data: fileURL });
    } else {
      alert("Please select a valid PDF file.");
    }
  };

  const renderImage = (src, alt = "") => (
    <div className="image-container">
      <img
        src={src}
        alt={alt}
        className="rounded shadow-sm"
        style={{ width: "80px", height: "80px", objectFit: "cover" }}
      />
    </div>
  );

  const handleSubmitWelcomeMessage = async () => {
    if (!pdfFile) {
      alert("Please select a PDF file first!");
      return;
    }
    const formData = new FormData();
    formData.append("pdf", pdfFile);

    try {
      const res = await axios.post(
        Config.base_url + "update/welcomeMessage/pdf",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (res.data.status) {
        toast.success("Welcome message updated successfully!");
      } else {
        toast.error("Error updating Welcome message!");
      }
    } catch (error) {
      toast.error("Error uploading PDF file!");
    }
  };

  const renderCompanyCards = () => {
    return (
      <div className="row g-3 g-lg-4 mt-1">
        {getCompanyName.data.map((company, index) => (
          <div key={index} className="col-12 col-xl-8 mx-auto">
            <div className="card h-100 border-0 shadow-sm hover-shadow transition">
              {/* Card Header */}
              <div className="card-header  border-bottom d-flex align-items-center py-3 px-3 px-md-4">
                <Building2 size={20} className="me-2" />
                <h5 className="mb-0 fw-semibold">Company Details</h5>
              </div>

              {/* Card Body */}
              <div className="card-body p-3 p-md-4">
                <div className="row g-3 g-md-4">
                  <div className="col-12 col-md-6">
                    <label className=" small fw-medium mb-2 d-block">
                      Company Name
                    </label>
                    <p className="fw-bold mb-0  fs-6">
                      {company.panel_name}
                    </p>
                  </div>
                  <div className="col-12 col-md-6">
                    <label className=" small fw-medium mb-2 d-block">
                      Short Name
                    </label>
                    <p className="fw-bold mb-0  fs-6">
                      {company.panel_short_name}
                    </p>
                  </div>
                  <div className="col-12 col-md-6">
                    <label className=" small fw-medium mb-2 d-block">
                      Version
                    </label>
                    <span className="badge bg-info  fs-6 px-3 py-2">
                      {company.version}
                    </span>
                  </div>
                  <div className="col-12 col-md-6">
                    <label className=" small fw-medium mb-2 d-block">
                      Panel Key
                    </label>
                    <code className="d-block p-2  rounded text-break small">
                      {company.panel_key}
                    </code>
                  </div>
                </div>
              </div>

              {/* Card Footer */}
              <div className="card-footer  border-top p-3 p-md-4">
                <button
                  className="btn btn-primary w-100 w-md-auto d-flex align-items-center justify-content-center gap-2 fw-semibold px-4 py-2"
                  onClick={() => setPanelDetailsModal(true)}
                >
                  <Pencil size={16} />
                  <span>Edit Company Information</span>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderEmailCards = () => {
    return (
      <div className="row g-3 g-lg-4 mt-1">
        {getCompanyName.data.map((email, index) => (
          <div key={index} className="col-12 col-xl-10 mx-auto">
            <div className="card shadow-sm border-0 h-100 hover-shadow transition">
              <div className="card-header  border-bottom d-flex align-items-center py-3 px-3 px-md-4">
                <Mail size={20} className="me-2" />
                <h5 className="mb-0 fw-semibold">Email Configuration</h5>
              </div>
              <div className="card-body p-3 p-md-4">
                <div className="row g-3 g-md-4">
                  <div className="col-12 col-sm-6 col-lg-4">
                    <label className=" small fw-medium mb-2 d-block">
                      Email Address
                    </label>
                    <p className="fw-bold mb-0  text-break">
                      {email.email}
                    </p>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-4">
                    <label className=" small fw-medium mb-2 d-block">
                      CC Email
                    </label>
                    <p className="fw-bold mb-0  text-break">
                      {email.cc_mail || (
                        <span className=" fst-italic">Not Set</span>
                      )}
                    </p>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-4">
                    <label className=" small fw-medium mb-2 d-block">
                      BCC Email
                    </label>
                    <p className="fw-bold mb-0  text-break">
                      {email.bcc_mail || (
                        <span className=" fst-italic">Not Set</span>
                      )}
                    </p>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-4">
                    <label className=" small fw-medium mb-2 d-block">
                      SMTP Host
                    </label>
                    <p className="fw-bold mb-0  text-break">
                      {email.smtphost}
                    </p>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-4">
                    <label className=" small fw-medium mb-2 d-block">
                      SMTP Port
                    </label>
                    <span className="badge bg-success fs-6 px-3 py-2">
                      {email.smtpport}
                    </span>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-4">
                    <label className=" small fw-medium mb-2 d-block">
                      Password
                    </label>
                    <p className="fw-bold mb-0 ">••••••••</p>
                  </div>
                </div>
              </div>
              <div className="card-footer  border-top p-3 p-md-4">
                <button
                  className="btn btn-primary w-100 w-md-auto d-flex align-items-center justify-content-center gap-2 px-4 py-2"
                  onClick={() => setShowEmailModal(true)}
                >
                  <Server size={16} />
                  <span>Update SMTP Configuration</span>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderImageCards = () => {
    return (
      <div className="row g-3 g-lg-4 mt-1">
        {getCompanyName.data.map((item, index) => (
          <div key={index} className="col-12 col-xl-10 mx-auto">
            <div className="card shadow-sm border-0 hover-shadow transition">
              {/* Card Header */}
              <div className="card-header  border-bottom d-flex align-items-center py-3 px-3 px-md-4">
                <Image size={20} className="me-2" />
                <h5 className="mb-0 fw-semibold">Brand Assets</h5>
              </div>

              {/* Card Body */}
              <div className="card-body p-3 p-md-4">
                <div className="row g-3 g-md-4">
                  {[
                    { label: "Favicon", src: item.favicon, type: 2 },
                    { label: "Logo", src: item.logo, type: 1 },
                    { label: "Login Background", src: item.loginimage, type: 4 },
                    { label: "Watermark", src: item.watermark, type: 3 },
                    // { label: "Landing Page Image", src: item.landing_image, type: 5 },
                    { label: "Loader Image", src: item.loader_image, type: 6 },
                  ].map((img, i) => (
                    <div key={i} className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <div className="text-center">
                        <label className=" small fw-medium mb-3 d-block">
                          {img.label}
                        </label>

                        {/* Image Container */}
                        <div className="position-relative d-inline-block">
                          <div
                            className="border rounded-3 overflow-hidden  p-3"
                            style={{ minHeight: "150px" }}
                          >
                            <img
                              src={
                                (img.type === 6 && (!img.src || img.src === ""))
                                  ? "https://cdn3d.iconscout.com/3d/premium/thumb/bitcoin-3d-icon-png-download-12385354.png"
                                  : (img.src || "https://cdn-icons-png.flaticon.com/512/2748/2748558.png")
                              }
                              alt={img.label}
                              className="img-fluid"
                              style={{
                                maxHeight: "120px",
                                width: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                          {/* Remove Button */}
                          {img.src && (
                            <button
                              type="button"
                              className="btn btn-danger btn-sm rounded-circle position-absolute shadow-sm"
                              onClick={() => Removeimages(img.type)}
                              style={{
                                top: "-8px",
                                right: "-8px",
                                width: "28px",
                                height: "28px",
                                padding: 0,
                                lineHeight: 1,
                              }}
                              title="Remove image"
                            >
                              ✕
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Card Footer */}
              <div className="card-footer  border-top p-3 p-md-4">
                <button
                  className="btn btn-primary w-100 w-md-auto d-flex align-items-center justify-content-center gap-2 px-4 py-2"
                  onClick={() => setshowImgModal(true)}
                >
                  <Camera size={16} />
                  <span>Update Brand Assets</span>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <Content button_status={false} Page_title="System">
        <div className="container-fluid px-2 px-md-3 px-lg-4">
          <Tabs
            defaultActiveKey={PageStatus}
            id="system-tabs"
            className="mb-4 nav-pills mb-3 mt-4 system-tabs"
            fill
            onSelect={setPageStatus}
          >
            <Tab
              eventKey="1"
              title={
                <span className="d-flex align-items-center gap-2 justify-content-center px-2 py-1">
                  <Building2 size={16} className="d-none d-sm-inline" />
                  <span>Company Info</span>
                </span>
              }
            >
              {renderCompanyCards()}
            </Tab>

            <Tab
              eventKey="2"
              title={
                <span className="d-flex align-items-center gap-2 justify-content-center px-2 py-1">
                  <Mail size={16} className="d-none d-sm-inline" />
                  <span>Email Config</span>
                </span>
              }
            >
              {renderEmailCards()}
            </Tab>

            <Tab
              eventKey="3"
              title={
                <span className="d-flex align-items-center gap-2 justify-content-center px-2 py-1">
                  <Image size={16} className="d-none d-sm-inline" />
                  <span>Brand Assets</span>
                </span>
              }
            >
              {renderImageCards()}
            </Tab>

            <Tab
              eventKey="4"
              title={
                <span className="d-flex align-items-center gap-2 justify-content-center px-2 py-1">
                  <Shield size={16} className="d-none d-sm-inline" />
                  <span>Disclaimer</span>
                </span>
              }
            >
              <div className="row g-3 g-lg-4 mt-1">
                <div className="col-12 col-xl-10 mx-auto">
                  <div className="card shadow-sm border-0">
                    <div className="card-header  border-bottom d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 py-3 px-3 px-md-4">
                      <div className="d-flex align-items-center">
                        <Shield size={20} className="me-2" />
                        <h5 className="mb-0 fw-semibold">
                          Disclaimer Message
                        </h5>
                      </div>
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="disclaimerSwitch"
                          checked={Number(getDissStatus) === 1}
                          onChange={updateDiscStatus}
                        />
                        <label
                          className="form-check-label fw-medium"
                          htmlFor="disclaimerSwitch"
                        >
                          {Number(getDissStatus) === 1 ? (
                            <span className="text-success">Active</span>
                          ) : (
                            <span className="text-danger">Inactive</span>
                          )}
                        </label>
                      </div>
                    </div>
                    <div className="card-body p-3 p-md-4">
                      <ReactQuill
                        value={diss}
                        onChange={setDiss}
                        theme="snow"
                        className="mb-4"
                        placeholder="Enter your disclaimer message here..."
                        style={{ minHeight: "200px" }}
                        modules={{
                          toolbar: [
                            [{ header: [1, 2, false] }],
                            ["bold", "italic", "underline"],
                            ["link", "image"],
                            [{ list: "ordered" }, { list: "bullet" }],
                            ["clean"],
                          ],
                        }}
                      />

                      <button
                        className="btn btn-danger w-100 w-md-auto d-flex align-items-center justify-content-center gap-2 px-4 py-2"
                        onClick={handleSubmit}
                      >
                        <FileText size={16} />
                        <span>Update Disclaimer</span>
                      </button>
                    </div>
                  </div>

                  {/* Welcome Message PDF Card */}
                  <div className="card shadow-sm border-0 mt-4">
                    <div className="card-header  border-bottom d-flex align-items-center py-3 px-3 px-md-4">
                      <FontAwesomeIcon
                        icon={faFilePdf}
                        className="me-2 text-danger"
                        size="lg"
                      />
                      <h5 className="mb-0 fw-semibold">Welcome Message PDF</h5>
                    </div>
                    <div className="card-body p-3 p-md-4 row">
                      <div className="mb-4 col-md-6">
                        <label
                          htmlFor="pdfUpload"
                          className="form-label fw-semibold d-flex align-items-center gap-2"
                        >
                          <Upload size={16} />
                          Select PDF File
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          id="pdfUpload"
                          accept="application/pdf"
                          onChange={handlePdfUpload}
                        />
                        <small className=" d-block mt-2">
                          Upload a PDF file to display as welcome message
                        </small>
                      </div>

                      {/* {pdfFile && (
                        <div className="alert alert-success d-flex align-items-start gap-2 mb-4 col-md-6">
                          <FontAwesomeIcon
                            icon={faFilePdf}
                            className="text-danger mt-1 flex-shrink-0"
                            size="lg"
                          />
                          <div>
                            <strong>Selected File:</strong>
                            <div className="text-break mt-1">
                              {pdfFile?.name || "Current PDF file"}
                            </div>
                          </div>
                        </div>
                      )} */}

                      {pdfFileExist.data && (
                        <div className="mb-4 col-6">
                          <h6 className="fw-semibold mb-3">PDF Preview:</h6>
                          <div className="border rounded-3 overflow-hidden">
                            <iframe
                              src={pdfFileExist.data}
                              title="PDF Preview"
                              width="95%"
                              height="200"
                              className="border-0 d-none d-md-block"
                            ></iframe>
                            <div className="d-block d-md-none p-4 text-center ">
                              <FontAwesomeIcon
                                icon={faFilePdf}
                                size="3x"
                                className="text-danger mb-3"
                              />
                              <p className="mb-2">
                                PDF preview not available on mobile devices
                              </p>
                              <a
                                href={pdfFileExist.data}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm"
                              >
                                Open PDF in New Tab
                              </a>
                            </div>
                          </div>
                        </div>
                      )}

                      <button
                        className="btn btn-info w-100 w-md-auto d-flex align-items-center justify-content-center gap-2 px-4 py-2"
                        onClick={handleSubmitWelcomeMessage}
                      >
                        <Upload size={16} />
                        <span>Update Welcome Message</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Tab>

            {Number(getDissStatus) === 1 && (
              <Tab
                eventKey="5"
                title={
                  <span className="d-flex align-items-center gap-2 justify-content-center px-2 py-1">
                    <Mail size={16} className="d-none d-sm-inline" />
                    <span>Email Preview</span>
                  </span>
                }
              >
                <div className="row g-3 g-lg-4 mt-1">
                  <div className="col-12 col-xl-10 mx-auto">
                    <div className="card shadow-sm border-0">
                      <div className="card-header  border-bottom d-flex align-items-center py-3 px-3 px-md-4">
                        <Mail size={20} className="me-2" />
                        <h5 className="mb-0 fw-semibold">
                          Email Preview & Testing
                        </h5>
                      </div>

                      <div className="card-body p-3 p-md-4">
                        <p className=" mb-4">
                          Send a test email to preview how your disclaimer and
                          email templates will appear to recipients.
                        </p>

                        {/* Email Input Section */}
                        <div className="row g-3 mb-4">
                          <div className="col-12 col-lg-8">
                            <label
                              htmlFor="testEmail"
                              className="form-label fw-medium"
                            >
                              Test Email Address
                            </label>
                            <input
                              type="email"
                              id="testEmail"
                              className="form-control"
                              placeholder="Enter email address"
                              value={inputs}
                              onChange={(e) => setInputs(e.target.value)}
                            />
                          </div>
                          <div className="col-12 col-lg-4 d-flex align-items-end">
                            <button
                              className="btn btn-success w-100 d-flex align-items-center justify-content-center gap-2 px-4 py-2"
                              onClick={() => {
                                if (!inputs) {
                                  toast.error("Please enter an email address!");
                                  return;
                                }
                                axios
                                  .post(Config.base_url + "check/Disclaimer", {
                                    Email: inputs,
                                  })
                                  .then((response) => {
                                    if (response.data) {
                                      toast.success(
                                        "Test email sent successfully!"
                                      );
                                    } else {
                                      toast.error("Error sending test email!");
                                    }
                                  })
                                  .catch(() => {
                                    toast.error("Error sending test email!");
                                  });
                              }}
                            >
                              <Send size={16} />
                              <span>Send Test Email</span>
                            </button>
                          </div>
                        </div>

                        {/* Info Alert */}
                        <div className="alert alert-info d-flex align-items-start border-0 shadow-sm">
                          <Globe size={20} className="me-3 mt-1 flex-shrink-0" />
                          <div>
                            <h6 className="fw-semibold mb-2">How it works:</h6>
                            <p className="mb-0 small">
                              Enter an email address and click "Send Test Email"
                              to receive a preview of your current email
                              template with disclaimer. The email will be sent
                              immediately, showing exactly how recipients will
                              see it.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>
            )}
          </Tabs>
        </div>

        {/* Modals */}
        <UpdateCompanyInfo
          data={getCompanyName.data}
          showModal={PanelDetailsModal}
          setshowModal={() => setPanelDetailsModal(false)}
        />
        <UpdateSmptDetails
          data={getCompanyName.data}
          showModal={ShowEmailModal}
          setshowModal={() => setShowEmailModal(false)}
        />
        <UpdateImages
          data={getCompanyName.data}
          showModal={showImgModal}
          setshowModal={() => setshowImgModal(false)}
        />
        <ToastButton />
      </Content>

      <style jsx>{`
        .hover-shadow {
          transition: all 0.3s ease;
        }
        .hover-shadow:hover {
          transform: translateY(-2px);
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
        }
        .transition {
          transition: all 0.3s ease;
        }
        .nav-pills .nav-link {
          border-radius: 0.5rem;
          font-weight: 500;
          transition: all 0.2s ease;
        }
        .nav-pills .nav-link:hover {
          background-color: rgba(13, 110, 253, 0.1);
        }
        .nav-pills .nav-link.active {
          background-color: #0d6efd;
        }
        @media (max-width: 576px) {
          .card-header h5 {
            font-size: 1rem;
          }
          .btn {
            font-size: 0.875rem;
          }
        }
      `}</style>
    </>
  );
};

export default System;